import { render, staticRenderFns } from "./AboutPageTitle.vue?vue&type=template&id=d5a6b31c"
import script from "./AboutPageTitle.vue?vue&type=script&lang=js"
export * from "./AboutPageTitle.vue?vue&type=script&lang=js"
import style0 from "./AboutPageTitle.vue?vue&type=style&index=0&id=d5a6b31c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports